import { useMemo } from "react";
import { buildTypeGraph } from "../services/buildTypeGraph";
import { resolveDocumentTypeData } from "../services/resolveDocumentTypeData";
import type { UseExpandGraphParams } from "../types";

export const useExpandGraph = ({ index, rootLabel }: UseExpandGraphParams) => {
    const config = resolveDocumentTypeData({ index });

    const flow = useMemo(
        () =>
            config
                ? buildTypeGraph({ types: config.types, field: config.field, rootLabel })
                : { nodes: [], edges: [] },
        [config, rootLabel],
    );

    return {
        nodes: flow.nodes,
        edges: flow.edges,
        fieldLabel: config?.label,
        isLoading: false,
        isError: false,
    };
};
